import { type ClusterGroup } from "~/features/selectionAssistant/bearing/types";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/search/clustergroups?selectionGroup=ROTARY");

export function getTileDisplayData(): Promise<ClusterGroup[]> {
  return fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  }).then((response) => {
    if (response.redirected) {
      window.location.reload();
    } else if (response.ok) {
      return response.json();
    }
  });
}
